export * from './new-edit-mercado-dialog';
export * from './mercado.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/mercado/index.ts